import React from "react";
import { Element } from "./Element";
import { InstructionAlert } from "./InstructionAlert";

export function ZipFileExtractionNotice(): React.ReactElement {
  return (
    <InstructionAlert type="info">
      If the file downloads as a .zip file, you can use{" "}
      <Element label="Extract Me" href="https://extract.me/" /> to extract the
      files before uploading them to Syla.
    </InstructionAlert>
  );
}
